"use client"

import { useEffect, useState, memo } from "react"
import MainLayout from "@/layout/MainLayout"
import StandardCard from "@/components/cards/StandardCard"
import { LISTING_GRID_CLASS, renderNewsGridWithAds } from "@/components/ListingGridWithAds"
import { useSearchParams } from "next/navigation"
import axiosInstance from "@/lib/axios"
import PageHeader from "@/components/ui/PageHeader"
import { LISTING_NEWS_PER_PAGE } from "@/lib/advertisement/constants"
import { CardGridSkeleton, EmptyState } from "@/components/ui/Skeleton"
import Pagination from "@/components/ui/Pagination"

const LatestNews = () => {
    const searchParams = useSearchParams();
    const categorySlug = searchParams.get('category') || ''

    const [news, setNews] = useState([])
    const [category, setCategory] = useState(null)
    const [pagination, setPagination] = useState({})
    const [loading, setLoading] = useState(true)
    const [currentPage, setCurrentPage] = useState(1)

    const fetchLatestNews = async (page = 1) => {
        try {
            setLoading(true)
            const response = await axiosInstance.get('/news/latest', {
                params: { category: categorySlug, page, limit: LISTING_NEWS_PER_PAGE }
            })
            if (response.data.success) {
                setNews(response.data.data)
                setPagination(response.data.pagination)
                setCategory(response.data.category)
            }
        } catch (error) {
            console.error('Error fetching latest news:', error)
        } finally {
            setLoading(false)
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    useEffect(() => {
        setCurrentPage(1)
    }, [categorySlug])

    useEffect(() => {
        fetchLatestNews(currentPage)
    }, [categorySlug, currentPage])

    const title = 'ताज्या बातम्या'
    const description = 'संपूर्ण महाराष्ट्रातील ताज्या बातम्या.'

    return (
        <MainLayout>
            <PageHeader
                title={title}
                description={description}
                accentName="Latest"
            />

            {loading && !news.length ? (
                <CardGridSkeleton count={9} />
            ) : news.length > 0 ? (
                <>
                    <div className={LISTING_GRID_CLASS}>
                        {renderNewsGridWithAds(news, 'latest_news', (item) => (
                            <StandardCard
                                key={item.id}
                                layout="col"
                                headline={item.title}
                                imageUrl={item.featuredImage}
                                data={item}
                            />
                        ))}
                    </div>

                    {pagination.totalPages > 1 && (
                        <div className="mt-12">
                            <Pagination
                                currentPage={pagination.currentPage}
                                totalPages={pagination.totalPages}
                                onPageChange={setCurrentPage}
                            />
                        </div>
                    )}
                </>
            ) : (
                <EmptyState message="सध्या कोणतीही ताज्या बातम्या उपलब्ध नाहीत." />
            )}
        </MainLayout>
    )
}

export default memo(LatestNews)
